import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithAuth } from './baseQuery';

export const payrollApi = createApi({
  reducerPath: 'payrollApi',
  baseQuery: createBaseQueryWithAuth(),
  tagTypes: ['Payroll'],
  endpoints: (builder) => ({
    // Generate payroll
    generatePayroll: builder.mutation({
      query: (data) => ({
        url: '/payroll/generate',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Payroll'],
    }),

    // Get payrolls
    getPayrolls: builder.query({
      query: (params) => ({
        url: '/payroll',
        params,
      }),
      providesTags: ['Payroll'],
    }),

    // Get payroll by ID
    getPayrollById: builder.query({
      query: (id) => `/payroll/${id}`,
      providesTags: (result, error, id) => [{ type: 'Payroll', id }],
    }),

    // Approve payroll
    approvePayroll: builder.mutation({
      query: ({ id }) => ({
        url: `/payroll/${id}/approve`,
        method: 'PUT',
      }),
      invalidatesTags: ['Payroll'],
    }),

    // Mark as paid payroll
    markAsPaidPayroll: builder.mutation({
      query: ({ id }) => ({
        url: `/payroll/${id}/mark-paid`,
        method: 'PUT',
      }),
      invalidatesTags: ['Payroll'],
    }),

    // Delete payroll
    deletePayroll: builder.mutation({
      query: (id) => ({
        url: `/payroll/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Payroll'],
    }),

    // Generate salary slip
    generateSalarySlip: builder.query({
      query: ({ payrollId, employeeId }) =>
        `/payroll/${payrollId}/employee/${employeeId}/salary-slip`,
    }),
  }),
});

export const {
  useGeneratePayrollMutation,
  useGetPayrollsQuery,
  useGetPayrollByIdQuery,
  useApprovePayrollMutation,
  useMarkAsPaidPayrollMutation,
  useDeletePayrollMutation,
  useGenerateSalarySlipQuery,
} = payrollApi;
